import { render, staticRenderFns } from "./InteriorPage.vue?vue&type=template&id=1be55d9a&scoped=true&"
import script from "./InteriorPage.vue?vue&type=script&lang=js&"
export * from "./InteriorPage.vue?vue&type=script&lang=js&"
import style0 from "./InteriorPage.vue?vue&type=style&index=0&id=1be55d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be55d9a",
  null
  
)

export default component.exports